import type { LoadMilestoneDto } from '../types/load-milestone-dto';

export default class MilestoneConstants {
  static defaultFilter: Partial<LoadMilestoneDto> = {
    limit: 15,
    offset: 0,
  };
}
